module.exports = __webpack_public_path__ + "img/resource-tech-image-61.613b2779.jpg";